module.exports = __webpack_public_path__ + "static/media/img-exhibition-map.ccde2a7c.svg";